import axios from "axios";
import api from "../api";

export default {
  CREATE_Label: (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          process.env.REACT_APP_BACKEND_URL + api.label.CREATE_Label(),
          data
        )
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  GET_Label: () => {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("access_token")}`;

      axios
        .get(process.env.REACT_APP_BACKEND_URL + api.label.GET_Label())
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  GET_Label_ALL: () => {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("access_token")}`;

      axios
        .get(process.env.REACT_APP_BACKEND_URL + api.label.GET_Label_ALL())
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  GET_Label_ALL_Search: (search = "", signal) => {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("access_token")}`;

      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/label/all`, {
          params: { search },
          signal,
        })
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  GET_ALL_INTERNAL_NOTES: (data) => {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${localStorage.getItem("access_token")}`;

      axios
        .get(
          process.env.REACT_APP_BACKEND_URL +
          api.internalnotes.GET_ALL_INTERNAL_NOTES(data)
        )
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },

  GET_Label_By_Id: (id, page = 1, limit = 10) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}${api.label.GET_Label_By_Id(id)}?page=${page}&limit=${limit}`
        )
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },


  Update_Label_By_Id: (id, data) => {
    return new Promise((resolve, reject) => {
      axios
        .put(
          process.env.REACT_APP_BACKEND_URL + api.label.Update_Label_By_Id(id),
          data
        )
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  },





  DELETE_Label_By_Id: (id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(process.env.REACT_APP_BACKEND_URL + api.label.DELETE_Label_By_Id(id))
        .then((res) => resolve(res))
        .catch((e) => reject(e));
    });
  },



};
